import { AppointmentType } from '../../constants'
import { Customer } from '../../types'
import { appointmentTypeToDisplayText } from '../appointmentTypeToDisplayText'

interface Props {
  customer: Customer
  type: AppointmentType
}

const appointmentToTitle = ({ customer, type }: Props) =>
  `${appointmentTypeToDisplayText[type]} w/${customer?.givenName} ${customer?.familyName}`

export { appointmentToTitle }
